import React, { useRef, useState, useLayoutEffect, useCallback } from "react";
import s from "./style.module.css";
import cn from "classnames";
import { tooltip } from "../../content/copy";
import track from "../../helpers/track";
// import { Button } from "../EditorButtons";

const Highlight = ({
  children,
  type,
  i,
  hasHover,
  onUpdate,
  phrase,
  onClick,
  words = [],
  ...rest
}) => {
  const ref = useRef();

  const [initialNum] = useState(i);

  const word = words[initialNum];

  const replacement = word?.replacement || {
    replacements: [],
  };

  if (word && replacement.position) {
    const [wordStart, wordEnd] = word.position;
    const [replacementStart, replacementEnd] = replacement.position;

    const difference = [wordStart - replacementStart, replacementEnd - wordEnd];

    replacement.replacements = replacement.replacements.map((d) => ({
      ...d,
      position: [rest.start - difference[0], rest.end + difference[1]],
    }));
  }

  const [boundingRect, setBoundingRect] = useState({});

  const setSize = useCallback(() => {
    if (ref.current) {
      setBoundingRect(ref.current.getBoundingClientRect().toJSON());
    }
  }, []);

  useLayoutEffect(() => {
    setSize();
  }, [setSize]);

  const hasReplacementsList =
    replacement.replacements.length > 0 &&
    replacement.replacements[0].phrase !== "";

  const suggestReplaceWord =
    replacement.replacements.length === 1 &&
    replacement.replacements[0].phrase === "";

  // console.log(replacement.replacements.length, replacement.replacements[0].p);

  return (
    <span
      className={cn(s.handle, {
        [s.onRight]:
          boundingRect.left >=
          window.innerWidth - (window.innerWidth >= 600 ? 280 : 190),
        [s.hasReplacements]: hasHover,
        [s.hasClick]: onClick,
        [s[type]]: type,
      })}
      ref={ref}
      onMouseEnter={setSize}
      onClick={onClick}
    >
      {children}
      <span className={s.border}>
        {hasHover && type === "feminine" && (
          <span className={s.replacements} contentEditable={false}>
            <p className={s.replacementsTitle}>
              <span
                dangerouslySetInnerHTML={{
                  __html: tooltip.femaleTitle.replace(/{{current}}/gi, phrase),
                }}
              />
            </p>
            <p>{tooltip.femaleCopy}</p>
          </span>
        )}

        {hasHover && replacement && type === "masculine" && (
          <span className={s.replacements} contentEditable={false}>
            <p className={s.replacementsTitle}>
              {/* Has replacements */}
              {hasReplacementsList && !suggestReplaceWord && (
                <>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: tooltip.text.replace(
                        /{{current}}/gi,
                        replacement.biased_phrase
                      ),
                    }}
                  />
                </>
              )}

              {/* No replacements suggested */}
              {!hasReplacementsList && !suggestReplaceWord && (
                <>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: tooltip.noReplacements.replace(
                        /{{current}}/gi,
                        phrase
                      ),
                    }}
                  />
                </>
              )}

              {/* Suggest removal of word */}
              {suggestReplaceWord && (
                <>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: tooltip.removeWord.replace(
                        /{{current}}/gi,
                        phrase
                      ),
                    }}
                  />
                </>
              )}
            </p>

            {hasReplacementsList && (
              <ul className={s.list}>
                {replacement.replacements.map(
                  ({ phrase, coding, position, biased_phrase }) => (
                    <li className={s.suggestion} key={phrase}>
                      <Highlight
                        type={coding}
                        onClick={() => {
                          track.replaceText(replacement.biased_phrase, phrase);
                          onUpdate(
                            rest.blockKey,
                            position[0],
                            position[1],
                            phrase
                          );
                        }}
                      >
                        {phrase}
                      </Highlight>
                    </li>
                  )
                )}
              </ul>
            )}

            {suggestReplaceWord && (
              <ul className={s.list}>
                {replacement.replacements.map(
                  ({ phrase, coding, position }) => (
                    <li className={s.suggestion} key={phrase}>
                      <Highlight
                        onClick={() => {
                          track.removeText(replacement.biased_phrase);
                          onUpdate(
                            rest.blockKey,
                            position[0],
                            position[1] + 1,
                            phrase
                          );
                        }}
                      >
                        {tooltip.removeText}
                      </Highlight>
                    </li>
                  )
                )}
              </ul>
            )}
          </span>
        )}
      </span>
    </span>
  );
};

export default Highlight;
